import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { clearFilters, setFilter, useData } from './dataStore';
import { NO_FILTERS, UNSET, activeCount, filterOptions, type CategoryFilter } from './filters';

/** One drop-down per filter of the category, with how many records each choice leaves. */
export function CategoryFilters({
  category,
  filters,
  inline,
}: {
  category: string;
  filters: CategoryFilter[];
  /** In a header row (label beside the drop-down) instead of stacked in the sidebar. */
  inline?: boolean;
}) {
  const { t } = useTranslation();
  const records = useData((s) => s.records);
  const selection = useData((s) => s.filters[category]) ?? NO_FILTERS;
  const inCategory = useMemo(
    () => Object.values(records).filter((r) => r.category === category),
    [records, category],
  );
  const active = activeCount(filters, selection);

  return (
    <div className={`cat-filters${inline ? ' inline' : ''}`}>
      {filters.map((f) => (
        <label key={f.field} className="small">
          <span className="muted">{t(f.labelKey)}</span>
          <select
            className="small"
            value={selection[f.field] ?? ''}
            onChange={(e) => setFilter(category, f.field, e.target.value)}
          >
            <option value="">{t('data.filters.all')}</option>
            {filterOptions(inCategory, filters, selection, f.field).map((o) => (
              <option key={o.value} value={o.value}>
                {o.value === UNSET ? t('data.filters.unset') : o.value} ({o.count})
              </option>
            ))}
          </select>
        </label>
      ))}
      {active > 0 && (
        <button className="link small" onClick={() => clearFilters(category)}>
          {t('data.filters.clear')}
        </button>
      )}
    </div>
  );
}
